// jQuery(".et_pb_section").each(function (index) {
//     jQuery(this).attr('data-offset-top',jQuery(this).offset().top).attr('data-translate',0)
// })

/**
 * Not sure what this is but causes console error
 * Error: Empty selector
 *     at e.parseSelector (scroll-timeline.js:1152:61)
 *     at e.parseQualifiedRule (scroll-timeline.js:1127:39)
 *     at e.transpileStyleSheet (scroll-timeline.js:914:30)
 */
// import './scroll-timeline';


// import LocomotiveScroll from 'locomotive-scroll';
// import   'locomotive-scroll/dist/locomotive-scroll.min.css';
import {gsap} from "gsap";
import {ScrollTrigger,} from "gsap/ScrollTrigger";
import ScrollSmoother from "./gsap/ScrollSmoother.min";


if (document.querySelector('body:not(.et-fb-root-ancestor)')) {
    window.$ = jQuery;


// jQuery('.success-tab-1').wrapAll('<div id="success-tab-1-container" class="tab-container"/>')
// jQuery('.success-tab-2').wrapAll('<div id="success-tab-2-container" class="tab-container"/>')
// jQuery('.success-tab-3').wrapAll('<div id="success-tab-3-container" class="tab-container"/>')
// jQuery('.success-tab-4').wrapAll('<div id="success-tab-4-container" class="tab-container"/>')
// jQuery('.tab-container').wrapAll('<div class="tab-containers"/>')

    jQuery(document).on('click', 'a[class*="success-tab-bt-"]', function (event) {
        event.preventDefault()
        event.stopImmediatePropagation();
        let button = jQuery(this),
            containerClass = button.attr("id"),
            container = jQuery(`.${containerClass}`)


        if (button.hasClass('active')) {
            return false
        }


        jQuery('a[class*="success-tab-bt-"]').not(button).removeClass('active')
        button.addClass('active')

        // if (typeof window.scroller !== 'undefined') {
        //     window.scroller.paused(true)
        // }

        jQuery('div[class*="success-tab-"]').not(container).hide().removeClass('show')
        container.show().addClass('show')

        // if (typeof window.scroller !== 'undefined') {
        //     ScrollTrigger.update()
        //     scroller.scrollTo(button, true, "top 150px")
        //     window.scroller.paused(false)
        //     ScrollTrigger.refresh()
        // }
        return false
    })


    jQuery(document).on('click', '.service-tab-button', function (event) {
        event.preventDefault()
        let button = jQuery(this),
            container = jQuery(`.${button.attr('id')}`)

        if (button.hasClass('active')) {
            return false
        }

        jQuery('.service-tab-button').not(button).removeClass('active')
        button.addClass('active')

        // window.scroller.paused(true)

        container.show().addClass('show')
        jQuery('.service-tab-container').not(container).hide().removeClass('show')


        // ScrollTrigger.update()

        // scroller.scrollTo(button, true, "top 150px")

        // window.scroller.paused(false)
        // ScrollTrigger.refresh()

        return false
    })


    if (window.fdcUseParallax) {

        gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
        ScrollTrigger.normalizeScroll(true)

        const markers = false;

        /**
         * !!!! NOTE !!!!
         * Adding negative top margin to the first divi section
         * causes whitespace at the bottom of the page with ScrollSmoother enabled.
         */


// create the smooth scroller FIRST!
        window.initSmoothScroller = () => {
            return ScrollSmoother.create({
                wrapper: '#et-main-area',
                smooth: 2,   // seconds it takes to "catch up" to native scroll position
                // effects: true // look for data-speed and data-lag attributes on elements and animate accordingly
                normalizeScroll: {
                    allowNestedScroll: true
                },
                // preventDefault:false
            });
        }

        // ScrollTrigger.observe({
        //     target: "body:not(.et-fb-root-ancestor) .agency-services-slider>div,.mobile-testimonial-container", // can be any element (selector text is fine)
        //     type: "touch,pointer,wheel,scroll", // comma-delimited list of what to listen for ("wheel,touch,scroll,pointer")
        //     // onUp: () => previous(),
        //     // onDown: (self) => {
        //     //     console.warn(self.deltaX);
        //     // },
        //     // onPress: (self) => {
        //     //     console.warn(self.deltaX);
        //     // },
        //     onDrag: (self) => {
        //
        //
        //         // $(self.target).prepend('<span>'+self.deltaY+'</span>')
        //
        //         if(self.deltaY <0.8 && self.deltaY>-0.8) {
        //                     if (self.deltaX < 0) {
        //                         $(self.target).slick("slickNext");
        //                     } else {
        //                         $(self.target).slick("slickPrev");
        //                     }
        //         }
        //
        //         // console.log(self.deltaY)
        //         // console.log(self.deltaX)
        //         // gsap.to(window, { scrollTo: { y: `+=${self.deltaX * 10}` } });
        //     }
        // });

        window.scroller = initSmoothScroller()


        /**
         * Header topbar
         */
        window.topbarHeight = $('#topbar').outerHeight();
        $(window).resize(() => {
            window.topbarHeight = $('#topbar').outerHeight();
        })
        window.showTopbar = gsap
            .from("#header", {
                // yPercent: -50,
                y: -topbarHeight,
                paused: true,
                duration: 0.4
            })
            .progress(1);


        // let lastScrollTop = 0,
        //     currentScrollDirection = 0;
        // $(window).scroll(function (event) {
        //     const st = $(this).scrollTop();
        //     if (st > lastScrollTop) {
        //         currentScrollDirection = 1
        //     } else {
        //         currentScrollDirection = -1
        //     }
        //     lastScrollTop = st;
        // });

        ScrollTrigger.create({
            start: "50px top",
            // scrollTrigger:'#header',
            // markers:markers,
            end: 99999,
            onUpdate: (self) => {

                // topbarHeight = $('#topbar').outerHeight()
                //
                // if(scroller.scrollTop()>=(topbarHeight)+50){
                //     showAnim.reverse()
                // }else{
                //     showAnim.play()
                // }

                if (!$('body').hasClass('mobile-nav-open')) {

                    if (self.direction === 1) {
                        $('body').addClass('hide-topbar')
                    } else {
                        $('body').removeClass('hide-topbar')
                    }
                    // console.log(currentScrollDirection)

                    // $('#logo-container a').html(self.start)

                    self.direction === -1 ? showTopbar.play() : showTopbar.reverse();
                }
            }
        });


        jQuery(document).on('parallaxPause', () => {
            ScrollTrigger.disable()
        })
        jQuery(document).on('parallaxEnable', () => {
            ScrollTrigger.enable()
        })
        jQuery(document).on('parallaxResume', () => {
            ScrollTrigger.enable()
            ScrollTrigger.refresh()

        })

        jQuery(document).on('parallaxRefresh', () => {
            ScrollTrigger.refresh()
        })


        /**
         * Parallax for case study images
         */
        //  scroller.effects("div:not(.work-gallery-section) >div >div >div.parallax-image", {speed: 1.3});
        // jQuery('.work-gallery-section .parallax-image').each(function (index, item) {
        //     let speed = 1 + (generateRandom(11, 50) / 100),
        //         lag = 1 + (generateRandom(0.1, 15) / 100)
        //     console.log({speed, lag})
        //     scroller.effects(jQuery(this), {speed, lag});
        // })
        //
        // function generateRandom(min = 0, max = 100) {
        //
        //     // find diff
        //     let difference = max - min;
        //
        //     // generate random number
        //     let rand = Math.random();
        //
        //     // multiply with difference
        //     rand = Math.floor(rand * difference);
        //
        //     // add with min value
        //     rand = rand + min;
        //
        //     return rand;
        // }


        /**
         * Home
         */
        if (jQuery('body.page-id-2').length) {

            // scroller.effects(".et_pb_section_0", {speed:0});
            // scroller.effects(".et_pb_section_1", {speed:1.3});
            // scroller.effects(".et_pb_section_2", {speed:1.4});
            // scroller.effects(".et_pb_section_3", {speed:1.4});
            // scroller.effects(".parallax-footer", {speed:2});
            //


            let mm = gsap.matchMedia();


            mm.add("(max-width: 768px)", () => {
                gsap.to('.et_pb_section_0', {
                    y: '100%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_1',
                        start: "top bottom",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });

                gsap.to('.et_pb_section_1', {
                    y: '20%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_2',
                        start: "top 80%",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });

                gsap.to('.et_pb_section_2', {
                    y: '70%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_3',
                        start: "top bottom",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });

                gsap.to('.et_pb_section_3', {
                    y: '20%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_4',
                        start: "top bottom",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });

                gsap.to('.et_pb_section_4', {
                    y: '70%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_6',
                        start: "top bottom",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });

                gsap.to('.et_pb_section_5', {
                    y: '50%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_6',
                        start: "top bottom",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });


                gsap.to('.et_pb_section_6', {
                    y: '30%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_7',
                        start: "top bottom",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });

                gsap.to('.et_pb_section_7', {
                    y: '100%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.parallax-footer',
                        start: "top bottom",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });
            })

            mm.add("(min-width: 768.98px)", () => {
                gsap.to('.et_pb_section_0', {
                    y: '100%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_1',
                        start: "top center",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });

                gsap.to('.et_pb_section_1', {
                    y: '30%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_2',
                        start: "top 80%",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });

                gsap.to('.et_pb_section_2', {
                    y: '60%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_3',
                        start: "top bottom",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });

                gsap.to('.et_pb_section_3', {
                    y: '60%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_4',
                        start: "top bottom",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });

                gsap.to('.et_pb_section_4', {
                    y: '40%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_6',
                        start: "top bottom",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });


                gsap.to('.et_pb_section_5', {
                    y: '50%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_6',
                        start: "top bottom",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });


                gsap.to('.et_pb_section_6', {
                    y: '40%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.et_pb_section_7',
                        start: "top bottom",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });

                gsap.to('.et_pb_section_7', {
                    y: '80%',
                    ease: "none",
                    scrollTrigger: {
                        trigger: '.parallax-footer',
                        start: "top bottom",
                        // end: "bottom bottom",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });
            })


            // gsap.to('.et_pb_section_1', {
            //     y: '50%',
            //     ease: "none",
            //     scrollTrigger: {
            //         // markers,
            //         trigger: '.et_pb_section_1',
            //         start: "top center",
            //         end: "top top",
            //         endTrigger: '.et_pb_section_2',
            //         scrub: 0.3,
            //         invalidateOnRefresh: true,
            //
            //     }
            // });
            //
            // gsap.to('.et_pb_section_3', {
            //     y: '80vh',
            //     ease: "none",
            //     scrollTrigger: {
            //         // markers,
            //         trigger: '.et_pb_section_4',
            //         start: "top 70%",
            //         // end: "top top",
            //         scrub: 0.3,
            //         invalidateOnRefresh: true,
            //         // endTrigger: '.et_pb_section_4'
            //     }
            // });
            //
            // gsap.to('.et_pb_section_4', {
            //     y: '50%',
            //     ease: "none",
            //     scrollTrigger: {
            //         // markers: markers,
            //         trigger: '.et_pb_section_4',
            //         start: "center center",
            //         end: "center center",
            //         scrub: 0.3,
            //         invalidateOnRefresh: true,
            //         endTrigger: '.parallax-footer'
            //     }
            // });

        }
        /**
         * End Home
         */


        /**
         * Work
         */
        if (jQuery('body.page-id-32').length) {
            gsap.to('.our-work-header', {
                y: '50%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.our-work-header',
                    start: "top top",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.all-work-list', {
                y: '400px',
                ease: "none",
                scrollTrigger: {
                    id: "workList",
                    // markers:markers,
                    trigger: '.all-work-list',
                    start: "bottom bottom",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


        }
        /**
         * End work
         */


        /**
         * Services
         */
        if (jQuery('body.page-id-93').length) {
            gsap.to('.et_pb_section_0', {
                y: '50%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_0',
                    start: "top top",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_1', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_2',
                    start: "top center",
                    // end: "top top",
                    // endTrigger:'.parallax-footer',
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_2', {
                y: '40%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_2',
                    start: "bottom center",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            // gsap.to('.parallax-footer', {
            //     y: '-50%',
            //     ease: "none",
            //     scrollTrigger: {
            //         // markers:markers,
            //         trigger: '.parallax-footer',
            //         start: "top bottom",
            //         // end: "bottom bottom",
            //         scrub: 0.3,
            //         invalidateOnRefresh: true,
            //     }
            // });

        }
        /**
         * end Services
         */


        /**
         * LinkedIn
         */
        if (jQuery('body.page-id-260').length) {
            gsap.to('.et_pb_section_0', {
                y: '50%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_0',
                    start: "top top",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_1', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_2',
                    start: "top bottom",
                    // end: "top top",
                    // endTrigger:'.parallax-footer',
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_2', {
                y: '10%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_2',
                    start: "bottom bottom",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_3', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.parallax-footer',
                    start: "top center",
                    // end: "bottom bottom",

                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            // gsap.to('.parallax-footer', {
            //     y: '-50%',
            //     ease: "none",
            //     scrollTrigger: {
            //         // markers:markers,
            //         trigger: '.parallax-footer',
            //         start: "top bottom",
            //         // end: "bottom bottom",
            //         scrub: 0.3,
            //         invalidateOnRefresh: true,
            //     }
            // });

        }
        /**
         * end LinkedIn
         */


        /**
         * Community
         */
        if (jQuery('body.page-id-1398').length) { //dev body.page-id-1398 //page-id-1686 live
            gsap.to('.et_pb_section_0', {
                y: '50%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_0',
                    start: "top top",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_1', {//video
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_1',
                    start: "top bottom",
                    // endTrigger:'.et_pb_section_1 .et_pb_video_box',
                    // end: "top center",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_2', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_2',
                    start: "top bottom",
                    // end: "top top",
                    // endTrigger:'.parallax-footer',
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_3', { //pricing
                y: '30%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_4',
                    start: "top bottom",
                    // end: "bottom center",
                    // end: "center center",
                    // endTrigger:'.et_pb_section_2',
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_4', {
                y: '50%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_5',
                    start: "top bottom",
                    end: "bottom top",
                    // end: "top center",
                    // endTrigger:'.et_pb_section_3',
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_5', {
                y: '200px',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_5',
                    start: "top center",
                    // end: "top bottom",
                    // end: "center center",
                    // endTrigger:'.et_pb_section_4',
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_6', {
                y: '40%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.parallax-footer',
                    start: "top bottom",
                    // end: "bottom bottom",

                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

        }
        /**
         * end Community
         */

        /**
         * About us
         */
        if (jQuery('body.page-id-30').length) {
            gsap.to('.et_pb_section_0', {
                y: '50vh',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_1',
                    start: "top 70%",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_1', {
                y: '50vh',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_2',
                    start: "top 70%",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_2', {
                y: '50vh',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_3',
                    start: "top bottom",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_3', {
                y: '50vh',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_4',
                    start: "top bottom",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_4', {
                y: '50vh',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.parallax-footer',
                    start: "top bottom",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            // gsap.to('.parallax-footer', {
            //     y: '-50%',
            //     ease: "none",
            //     scrollTrigger: {
            //         markers:markers,
            //         trigger: '.parallax-footer',
            //         start: "top bottom",
            //         // end: "bottom bottom",
            //         scrub: 0.3,
            //         invalidateOnRefresh: true,
            //     }
            // });

        }
        /**
         * end About us
         */


        /**
         * Team
         */
        if (jQuery('body.page-id-29').length) {
            gsap.to('.et_pb_section_0', {
                y: '600px',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_1',
                    start: "top center",
                    end: "bottom top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_1', {
                y: '70%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_2',
                    start: "top bottom",
                    // end: "bottom top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_2', {
                y: '600px',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.parallax-footer',
                    start: "top center",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            // gsap.to('.et_pb_section_3--', {
            //     y: '50%',
            //     ease: "none",
            //     scrollTrigger: {
            //         // markers:markers,
            //         trigger: '.et_pb_section_3',
            //         start: "top bottom",
            //         end: "top top",
            //         endTrigger: '.parallax-footer',
            //         scrub: 0.3,
            //         invalidateOnRefresh: true,
            //     }
            // });


        }
        /**
         * end Team
         */

        /**
         * Careers
         */
        if (jQuery('body.page-id-979').length) {
            gsap.to('.et_pb_section_0', {
                y: '500px',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_1',
                    start: "top center",
                    // end: "bottom top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_1', {
                y: '600px',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.parallax-footer',
                    start: "top center",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            // gsap.to('.et_pb_section_3--', {
            //     y: '50%',
            //     ease: "none",
            //     scrollTrigger: {
            //         // markers:markers,
            //         trigger: '.et_pb_section_3',
            //         start: "top bottom",
            //         end: "top top",
            //         endTrigger: '.parallax-footer',
            //         scrub: 0.3,
            //         invalidateOnRefresh: true,
            //     }
            // });


        }
        /**
         * end Careers
         */

        /**
         * Insights page
         */
        if (jQuery('body.page-id-19').length) {
            gsap.to('.insight-header', {
                y: '50%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.all-insights-list',
                    start: "top center",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.all-insights-list', {
                y: '600px',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.parallax-footer',
                    start: "top center",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            // gsap.to('.et_pb_section_2', {
            //     y: '100%',
            //     ease: "none",
            //     scrollTrigger: {
            //         trigger: '.et_pb_section_1',
            //         start: "40% top",
            //         end: "top top",
            //         endTrigger:'.et_pb_section_2',
            //         scrub: 0.3,
            //         invalidateOnRefresh: true,
            //
            //     }
            // });

            // gsap.to('.et_pb_section_3', {
            //     y: '50%',
            //     ease: "none",
            //     scrollTrigger: {
            //         // markers: markers,
            //         trigger: '.et_pb_section_3',
            //         start: "center center",
            //         end: "center center",
            //         scrub: 0.3,
            //         invalidateOnRefresh: true,
            //         endTrigger:'.parallax-footer'
            //     }
            // });
            //
            // setTimeout(()=>{
            //     ScrollTrigger.refresh()
            // },300)

        }
        /**
         * end Insights page
         */

        /**
         * Single insight
         */
        if (jQuery('body.single-insight').length) {
            gsap.to('.insight-header', {
                y: '50%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.insight-parallax',
                    start: "top center",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et-boc', {
                y: '600px',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.parallax-footer',
                    start: "top center",
                    // end: "bottom bottom",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });
        }
        /**
         * End single insight
         */

        /**
         * Privacy policy page
         */
        // if (jQuery('body.page-id-3').length) {
        //     gsap.to('.et_pb_section_0', {
        //         y: '100vh',
        //         ease: "none",
        //         scrollTrigger: {
        //             markers:markers,
        //             trigger: '.privacy-policy',
        //             start: "bottom top",
        //              end: "bottom top",
        //             scrub: 0.3,
        //             invalidateOnRefresh: true,
        //         }
        //     });
        //
        // }
        /**
         * end Privacy policy page
         */


        /**
         * Linkedin Management
         */
        if (jQuery('body.page-id-2871').length) {
            gsap.to('.et_pb_section_0', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_1',
                    start: "top 75%",
                     end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });



            gsap.to('.et_pb_section_1', {
                y: '10%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_2',
                    start: "top 55%",
                    end: "top 10%",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });



            gsap.to('.et_pb_section_3', {
                y: '10%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_4',
                    start: "top 70%",
                    end: "top 10%",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_4', {
                y: '30%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_5',
                    start: "top 60%",
                    end: "top 10%",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_5', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_6',
                    start: "top 70%",
                    end: "top 10%",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });



            gsap.to('.et_pb_section_6', {
                y: '30%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.parallax-footer',
                    start: "top 70%",
                    end: "top 10%",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });
            /**
             * End linkedin management
             */
        }






        /**
         * Linkedin packages
         */
        if (jQuery('body.page-id-2892').length) {
            gsap.to('.et_pb_section_0', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_1',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_1', {
                y: '30%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.parallax-footer',
                    start: "top 70%",
                    end: "top 10%",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            /**
             * End Linkedin packages
             */
        }





        /**
         * Agency
         */
        if (jQuery('body.page-id-2904').length) {
            let mm = gsap.matchMedia();

            mm.add("(min-width: 979.98px)", () => {
                gsap.to('.et_pb_section_0', {
                    y: '20%',
                    ease: "none",
                    scrollTrigger: {
                        // markers: true,
                        trigger: '.et_pb_section_1',
                        start: "top 80%",
                        end: "top top",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });
            })
            mm.add("(max-width: 980px)", () => {
                gsap.to('.et_pb_section_0', {
                    y: '20%',
                    ease: "none",
                    scrollTrigger: {
                        // markers: true,
                        trigger: '.et_pb_section_2',
                        start: "top 80%",
                        end: "top top",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });
            })

            gsap.to('.et_pb_section_1', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_3',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_2', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_3',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_3', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_4',
                    start: "top 80%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_4', {
                y: '30%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.et_pb_section_5',
                    start: "top 65%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_5', {
                y: '15%',
                ease: "none",
                scrollTrigger: {
                    // markers:markers,
                    trigger: '.parallax-footer',
                    start: "top 80%",
                    end: "top 10%",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            /**
             * End Agency
             */
        }



        /**
         * Branding
         */
        if (jQuery('body.page-id-2917').length) {

                gsap.to('.et_pb_section_0', {
                    y: '20%',
                    ease: "none",
                    scrollTrigger: {
                        // markers: true,
                        trigger: '.et_pb_section_1',
                        start: "top bottom",
                        end: "top top",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });


            gsap.to('.et_pb_section_1', {
                y: '15%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_2',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_2', {
                y: '10%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_3',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_3', {
                y: '15%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.parallax-footer',
                    start: "top 80%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });



            /**
             * End Branding
             */
        }


        /**
         * Websites
         */
        if (jQuery('body.page-id-2924').length) {

            gsap.to('.et_pb_section_0', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_1',
                    start: "top bottom",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_1', {
                y: '15%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_2',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_2', {
                y: '5%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_3',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_3', {
                y: '15%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.parallax-footer',
                    start: "top 80%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });



            /**
             * End Websites
             */
        }


        /**
         * personal-branding-sales-sheet
         */
        if (jQuery('body.page-id-3181').length) {

            gsap.to('.et_pb_section_0', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_1',
                    start: "top bottom",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_1', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_2',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_2', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_3',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_3', {
                y: '30%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_4',
                    start: "top 80%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            let mm = gsap.matchMedia();


            mm.add("(min-width: 979.98px)", () => {
                gsap.to('.et_pb_section_4', {
                    y: '13%',
                    ease: "none",
                    scrollTrigger: {
                        // markers: true,
                        trigger: '.et_pb_section_5',
                        start: "top 75%",
                        end: "top top",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });
            })
            mm.add("(max-width: 980px)", () => {
                gsap.to('.et_pb_section_4', {
                    y: '5%',
                    ease: "none",
                    scrollTrigger: {
                        // markers: true,
                        trigger: '.et_pb_section_5',
                        start: "top 75%",
                        end: "top top",
                        scrub: 0.3,
                        invalidateOnRefresh: true,
                    }
                });
            })


            gsap.to('.et_pb_section_5', {
                y: '25%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.parallax-footer',
                    start: "top 80%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            /**
             * End personal-branding-sales-sheet
             */
        }




        /**
         * organic-content-creation
         */
        if (jQuery('body.page-id-2933').length) {

            gsap.to('.et_pb_section_0', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_1',
                    start: "top bottom",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_1', {
                y: '15%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_2',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_2', {
                y: '7%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_3',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_3', {
                y: '15%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.parallax-footer',
                    start: "top 80%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });



            /**
             * End organic-content-creation
             */
        }



        /**
         * paid-media
         */
        if (jQuery('body.page-id-2940').length) {

            gsap.to('.et_pb_section_0', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_1',
                    start: "top bottom",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_1', {
                y: '15%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_2',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_2', {
                y: '7%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_3',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_3', {
                y: '15%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.parallax-footer',
                    start: "top 80%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });



            /**
             * End paid-media
             */
        }



        /**
         * lead-generation
         */
        if (jQuery('body.page-id-2952').length) {

            gsap.to('.et_pb_section_0', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_1',
                    start: "top bottom",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_1', {
                y: '15%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_2',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_2', {
                y: '10%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_3',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_3', {
                y: '15%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.parallax-footer',
                    start: "top 80%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });



            /**
             * End lead-generation
             */
        }



        /**
         * audits
         */
        if (jQuery('body.page-id-2947').length) {

            gsap.to('.et_pb_section_0', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_1',
                    start: "top bottom",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_1', {
                y: '15%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_2',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_2', {
                y: '10%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_3',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_3', {
                y: '15%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.parallax-footer',
                    start: "top 80%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });



            /**
             * End audits
             */
        }



        /**
         * community
         */
        if (jQuery('body.page-id-1686').length) {

            gsap.to('.et_pb_section_0', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_1',
                    start: "top bottom",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_1', {
                y: '10%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_2',
                    start: "top 80%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_2', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_3',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_3', {
                y: '25%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_4',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            gsap.to('.et_pb_section_4', {
                y: '25%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.et_pb_section_5',
                    start: "top 60%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to('.et_pb_section_5', {
                y: '20%',
                ease: "none",
                scrollTrigger: {
                    // markers: true,
                    trigger: '.parallax-footer',
                    start: "top 75%",
                    end: "top top",
                    scrub: 0.3,
                    invalidateOnRefresh: true,
                }
            });


            /**
             * End community
             */
        }

        /**
         * End use parallax
         */
    }


//var allSections = jQuery('.reveal');
//allSections.wrapAll('<div class="container"/>');
// jQuery('body').attr('smooth-wrapper','')
// jQuery('#et-main-area').attr('''smooth-content','')

//
// let lastScrollTop = 0;
// window.onscroll = function () {
//
//
//     // let prevSection = jQuery(".et_pb_section").first().offset().top
//
//     jQuery(".et_pb_sectionss").each(function (index) {
//
//         let section = jQuery(this)
//
//         if (!section.isInViewport()) {
//             section.removeClass('is-inview')
//             return
//         }
//         if (!section.hasClass('is-inview')) {
//             section.addClass('is-inview')
//         }
//
//         let prevSection = section.prev(),
//             prevSectionHeight = prevSection.outerHeight() ?? 0,
//             scrollPosition = jQuery(window).scrollTop(),
//             scrollDirection = scrollPosition > lastScrollTop ? 'down' : 'up',
//             scrollChange = scrollPosition - lastScrollTop,
//             sectionPrevTranslate = section.attr('data-translate'),
//
//             // sectionTop = section.offset().top,
//             sectionTop = section.data('offset-top'),
//             sectionHeight = section.outerHeight(),
//             nextSection = section.next()
//
//         lastScrollTop = scrollPosition
//
//
//         console.log(sectionPrevTranslate - (3 * index))
//
//         // if(section.attr('data-translate')<sectionHeight){
//         section.attr('data-translate', (3 * index))
//         // }
//         section.css("transform", `translateY(-${section.attr('data-translate')}px)`)
//
//
//         /**
//          * !!!!!!!!! possibly of reducing the next sections top margin // or do the next sections in reverse top margin
//          */
//
//         // section.css('margin-bottom',-((jQuery(window).scrollTop()) +prevSection.outerHeight()) + "px")
//         if (nextSection.length && false) {
//             let sectionHeight = section.outerHeight(),
//                 nextSectionTop = nextSection.offset().top,
//                 sectionScrollTop = scrollPosition - nextSectionTop,
//                 nextSectionScrollTop = -(scrollPosition - nextSectionTop + scrollPosition - sectionScrollTop),
//                 move = (scrollPosition) - (sectionHeight + sectionTop)
//
//             console.log({
//                 move,
//                 sectionTop,
//                 scrollPosition,
//                 sectionHeight,
//                 nextSectionTop,
//                 sectionScrollTop,
//                 nextSectionScrollTop
//             })
//             // console.log({move})
//             // console.log(nextSectionScrollTop )
//             // section.css('transform', `translateY(${move}px)`).css('z-index',index)
//             // nextSection.css('margin-top', -move+ "px")
//             // if(move<sectionHeight) {
//
//             // }
//             // section.css('margin-bottom', -((nextSection.offset().top - section.offset().top + sectionHeight)) + "px")
//             // section.css('margin-bottom', -((nextSection.offset().top - section.offset().top + sectionHeight)) + "px")
//         }
//     })
//
//     // jQuery(".et_pb_section.is-inview").stop().animate({
//     //     "marginBottom": -(jQuery(window).scrollTop()) + "px",
//     // });
// };
//
//
// jQuery('body:not(.et-fb) .et_pb_section-sss').each(function (index, section) {
//
//     jQuery(this).wrap('<div></div>')
//
//     const sectionOffsetTop = section.offsetTop,
//         sectionHeight = section.offsetHeight,
//         prevSection = jQuery(this).prev(),
//         prevSectionOffsetTop = prevSection.length ? prevSection.offset().top : 0,
//         prevSectionHeight = prevSection.length ? prevSection.outerHeight() : 0
//
//
//     // if (prevSection.length) {
//
//     console.log({prevSectionOffsetTop, prevSectionHeight})
//     console.log(prevSection[0])
//     jQuery(this)[0].animate(
//         {
//             // transform: ['translateY(0)', `translateY(${window.pageYOffset/4}px)`]
//             // transform: ['scale(0)', 'scale(1)']
//             // transform: [`matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -10, 0, 1)`,`matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 705.6, 0, 1)`]
//             // marginBottom: [0,-200]
//             opacity: [1, 0]
//         },
//         {
//             // duration: 10000,
//             // fill: 'both',
//             // timeline: new ViewTimeline({ subject: section }),
//             // delay: { phase: 'enter', percent: CSS.percent(100) },
//
//             timeline: new ScrollTimeline({
//                 scrollOffsets: [
//                     {target: section, edge: 'end', threshold: 0},
//                     {target: section, edge: 'start', threshold: 1},
//                     CSS.px(sectionOffsetTop + sectionHeight - window.innerHeight),
//                     CSS.px(sectionOffsetTop + 200),
//
//                 ]
//             })
//         }
//     )
//     // }
// })
//
//
// const parallaxSections = document.querySelectorAll('.et_pb_sectionsssss')
//
// if (parallaxSections.length)
//     parallaxSections.forEach((section, index) => {
//         const sectionOffsetTop = section.offsetTop,
//             sectionHeight = section.offsetHeight
//
//         const parallaxSectionTimeline = new ScrollTimeline({
//             source: document.ScrollingElement,
//             orientation: 'block',
//             // scrollOffsets: [
//             //     {target: section, edge: 'end', threshold: '1'},
//             //     {target: section, edge: 'start', threshold: '1'},
//             // ]
//
//             scrollOffsets: [
//                 CSS.px(sectionOffsetTop + sectionHeight - window.innerHeight),
//                 CSS.px(sectionOffsetTop - window.innerHeight),
//
//             ]
//
//         })
//
//         console.log({
//             sectionOffsetTop, sectionHeight
//         })
//         //
//         section.animate(
//             {transform: ['translateY(0)', `translateY(-${sectionHeight}px)`]},
//             // {
//             //     transform: [
//             //         'perspective(1000px) rotateX(45deg)',
//             //         'perspective(1000px) rotateX(0)',
//             //     ]
//             // },
//             {
//                 duration: 10000,
//                 timeline: parallaxSectionTimeline
//             }
//         )
//     })
//


    /*
    Working paralax but needs to be done custom per page
    jQuery('.et_pb_section').wrap('<div></div>')

    jQuery(document).on('scroll', function () {
        var scrollPos = jQuery(this).scrollTop();


        // jQuery('.et_pb_section_0').css({
        //     'position': `sticky`,
        //     top:0
        // });

        let prevSection = jQuery('.et_pb_section_1'),
            prevSectionHeight = prevSection.outerHeight(),
            sectionScrollTransform = scrollPos / 2,
            sectionTransform = sectionScrollTransform > prevSectionHeight ? prevSectionHeight : sectionScrollTransform,

            lastSection = jQuery('.et_pb_section').last(),
            lastSectionHeight = lastSection.outerHeight(),
            footerScrollTransform = lastSection.offset().top -(scrollPos) - window.outerHeight + (lastSectionHeight),
            footerTransform = footerScrollTransform > lastSectionHeight ? lastSectionHeight : footerScrollTransform,
            footerOffsetTop = jQuery('.parallax-footer').offset().top - jQuery(window).scrollTop() - jQuery('.parallax-footer').outerHeight()

        // console.log(footerScrollTransform)


        jQuery('.et_pb_section_2').css({
            'transform': `translateY(-${(sectionTransform)}px)`,
            marginBottom: `-${sectionTransform}px`
        });

        if (footerScrollTransform < 0) {
            console.log(footerScrollTransform)

            // jQuery('.parallax-footer >div').attr('style',`transform:translateY(${(footerScrollTransform)}px)`)

            jQuery('.parallax-footer >div').css({
                // opacity:0,
                // transform: `translateY(${(footerScrollTransform)}px)`,
                marginTop: `${(footerScrollTransform/2)}px`
            });
        }


        // console.log(scrollPos)
        //
        // jQuery('.parallax-section:nth-of-type(2)').css({
        //     'top': (scrollPos / -3.5) + 'px'
        // });
        // jQuery('.parallax-section:nth-of-type(3)').css({
        //     'top': (scrollPos / -2.8) + 'px'
        // });
        // jQuery('.parallax-section:nth-of-type(4)').css({
        //     'top': (scrollPos / -2) + 'px'
        // });
    })

    */

}
